import React, { useState } from "react";
import { useFormikContext } from "formik";
import Image from "components/Image";
import ExternalLink from "components/ExternalLink";
import Button from "components/Form/fields/Button";
import Separator from "components/Separator";
import { prepareImportFromServiceProduct } from "utils/integrations";
import { useIsMounted } from "utils/hooks";
import Pill from "components/Pill";
import upperFirst from "lodash/upperFirst";
import { DIMENSIONS, ICON_DIMENSIONS } from "utils/constants/image";
import { PRIORITY_FIT_COVER } from "utils/constants/ui";

const ImportProductCard = ({ model, isFirst, isLast, isActive, onClick }) => {
  const { name, createdAt, adminUrl, service, priceRange, imported } = model;
  const [loading, setLoading] = useState(false);
  const isMounted = useIsMounted();

  const { setFieldValue, setFieldTouched, submitForm } = useFormikContext();

  const actions = (
    <div className="flex flex-row">
      {imported ? (
        <Pill copy="Imported" />
      ) : (
        <Button
          copy="Import"
          theme="slim"
          loading={loading}
          disabled={imported}
          onClick={() => {
            setLoading(true);

            const prepared = prepareImportFromServiceProduct(model);

            setFieldValue("products", [prepared]);
            setFieldTouched("products", true);

            setTimeout(submitForm, 100);
            setTimeout(() => {
              if (isMounted.current) {
                setLoading(false);
              }
            }, 500);
          }}
        />
      )}
    </div>
  );

  return (
    <div className="hairline-1 shadow-0 ba br2 bg-white w-100 relative cell-grow">
      <div className="flex flex-column bb hairline-1 justify-between">
        <div className="ph2 pv2 flex flex-row">
          {model.image && (
            <div className="relative">
              <Image
                src={model.image}
                alt={name}
                {...DIMENSIONS.PRODUCT_CARD}
                {...PRIORITY_FIT_COVER}
              />
            </div>
          )}
          <div className="w-100 flex flex-row items-center justify-between">
            <div className="f4 fw5 flex pl2">{name}</div>
            <div className="dn flex-ns flex-column justify-center items-end pl2">
              <div className="f4 fw5">{priceRange}</div>
              <Separator customClasses={{ container: "w-100 pv2 dib" }} />
              {actions}
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-between dn-ns ph3 pb3">
          <div className="f4 fw5">{priceRange}</div>
          {actions}
        </div>
        <div style={{ height: 43 }} className="w-100"></div>
        <div className="absolute bottom-0 right-0 left-0 z-1 center flex flex-row justify-between items-center w-100 bt hairline-1 pa2 bg-white f6">
          <div className="flex flex-row items-center pl2">
            <Image
              src={`/assets/integrations/${service}/icon.png`}
              {...ICON_DIMENSIONS[service]}
              alt={service}
            ></Image>
            <div className="f7 fw5 flex-shrink-0 pl2">Created: {createdAt}</div>
          </div>
          <ExternalLink
            copy={`View on ${upperFirst(service)}`}
            href={adminUrl}
          />
        </div>
      </div>
    </div>
  );
};

export default ImportProductCard;
